import { render, staticRenderFns } from "./FullOfferMarketsStandardNumbers.vue?vue&type=template&id=52a28a98&scoped=true"
import script from "./FullOfferMarketsStandardNumbers.vue?vue&type=script&lang=js"
export * from "./FullOfferMarketsStandardNumbers.vue?vue&type=script&lang=js"
import style0 from "./FullOfferMarketsStandardNumbers.vue?vue&type=style&index=0&id=52a28a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a28a98",
  null
  
)

export default component.exports